/** Required to phase out native bottom tab navigation */
export const NativeAppVersionWithRemovedTabNav = 257
